import clsx from "clsx";
import { tile, tileTitle } from "./Tile.css";

export interface TileProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "title"
> {
  /** Optional heading rendered at the top of the tile. */
  title?: string;
  /** Tile content. */
  children: React.ReactNode;
}

export function Tile({ title, children, className, ...props }: TileProps) {
  return (
    <div className={clsx(tile, className)} {...props}>
      {title && <p className={tileTitle}>{title}</p>}
      {children}
    </div>
  );
}
